export const DEFAULT_CURRENCY = 'TST'
export const EMPTY_MONEY = '--'
